exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.custom-select {\n  background-image: linear-gradient(45deg, transparent 50%, #0669f9 50%),\n    linear-gradient(135deg, #0669f9 50%, transparent 50%);\n  background-position: calc(100% - 20px) calc(1em + 2px),\n    calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n  background-size: 5px 5px, 5px 5px, 1px 1.5em;\n  background-repeat: no-repeat;\n  padding-right: 35px;\n}\n", ""]);

// exports
